module.exports = {
    Error: {
        displayMultipleErrorsInHistory : false,
    },
};


// WEBPACK FOOTER //
// ./settings/error.js